import { render, staticRenderFns } from "./ShopTransfer.vue?vue&type=template&id=64bab36e&scoped=true&"
import script from "./ShopTransfer.vue?vue&type=script&lang=js&"
export * from "./ShopTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ShopTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShopTransfer.vue?vue&type=style&index=1&id=64bab36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bab36e",
  null
  
)

export default component.exports